var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#026B0C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1253 18.72H24.4573C24.6253 18.72 24.8253 18.728 25.0573 18.744C25.2893 18.752 25.5133 18.776 25.7293 18.816C26.6653 18.96 27.4493 19.284 28.0813 19.788C28.7213 20.284 29.2013 20.908 29.5213 21.66C29.8413 22.412 30.0013 23.248 30.0013 24.168C30.0013 25.464 29.6853 26.58 29.0533 27.516C28.4293 28.444 27.4973 29.076 26.2573 29.412C25.9613 29.492 25.6733 29.548 25.3933 29.58C25.1133 29.604 24.7893 29.616 24.4213 29.616H20.1253V27.588H24.3853C24.5373 27.588 24.7093 27.58 24.9013 27.564C25.1013 27.548 25.2893 27.52 25.4653 27.48C26.0173 27.352 26.4653 27.12 26.8093 26.784C27.1613 26.44 27.4173 26.04 27.5773 25.584C27.7373 25.12 27.8173 24.648 27.8173 24.168C27.8173 23.688 27.7373 23.216 27.5773 22.752C27.4173 22.288 27.1613 21.888 26.8093 21.552C26.4653 21.208 26.0173 20.976 25.4653 20.856C25.2893 20.808 25.1013 20.78 24.9013 20.772C24.7093 20.756 24.5373 20.748 24.3853 20.748H20.1253V18.72ZM20.1253 29.616L22.3573 28.92L30.3613 36H27.3133L20.1253 29.616ZM20.1733 25.02V23.304H31.8013V25.02H20.1733ZM24.2413 20.436V18.72H31.7533V20.436H24.2413Z",
    fill: "#026B0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.5b0f1d45318499dd6598441ac28d9f2c.svg";
export { ForwardRef as ReactComponent };